<template>
  <app-page-subsection v-if="!!data?.length">
    <template #title>
      <span v-html="title" />
    </template>
    <blog-post-card-carousel :list="data" />
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";
import type { TagPageView } from "~/business-areas/tag-page/composables/tag-page-view.hook";
import type { BlogPostPage } from "~~/model/blog.model";

const properties = defineProps<{
  view: TagPageView;
  courses: CourseListView[];
}>();

const title = computed(
  () =>
    `Articles et contenus - <span class="font-normal">${properties.view.tag.label}</span>`,
);

const { data } = useLazyFetch("/api/blog/posts", {
  query: {
    related_courses: computed(() =>
      properties.courses.map((course) => course.slug),
    ),
  },
  default: () => [] as BlogPostPage[],
  server: false,
});
</script>
